customElements.define('recently-viewed-products', class RecentlyViewedProducts extends HTMLElement {
  constructor() {
    super();

    this.containers = [
      this.querySelector('.splide__list'),
      this.querySelector('.grid')
    ];

    this.productHtml = [];

    // Hide section if no history data found
    // History data is set from global.js 
    this.history = sessionStorage.getItem('Woolman_Product_History') ? sessionStorage.getItem('Woolman_Product_History').split(',') : [];
    if (!this.history || this.history.length === 0) {
      this.containers.forEach((container) => {
        if (!container) return;
        const section = container.closest('recently-viewed-products');
        section.setAttribute('hidden', true);
      })
    };

    this.fetchProductHtml();
    this.closest('.shopify-section').addEventListener('section:in-viewport', () => {
      this.renderContainers();
    });
  }

  /* This function fetches item HTML snippets and passes them to initContainer function */
  async fetchProductHtml() {
    const promises = [];
    const rootUrl = window.routes.root == '/' ? '/' : window.routes.root + '/'; // if user has selected locale convert root url from /en-gb to /en-gb/
    this.history.forEach((productHandle) => {
      promises.push(fetch(`${rootUrl}products/${productHandle}?view=ajax-card`));
    });

    const settledPromises = await Promise.allSettled(promises);
    settledPromises.forEach(async (promise) => {

      try {
        const res = await promise.value;
        if (res.status !== 200) { throw res.status }
        const html = await res.text();

        this.productHtml.push(html);
      } catch(err) {
        console.error(err)
        return;
      }
    });

    return this.productHtml;
  }

  /**
   * Initialize the container with required data
   * @param {HTMLElement} container 
   */
  async renderContainers() {

    if (this.productHtml.length == 0) {
      this.setAttribute('hidden', true);
      return;
    };

    await this.containers.forEach(async (container) => {
      if (!container) return;
        // Get class of first child in provided container
      container.dataset.firstChildClass = container.firstElementChild.className;

      // Get node type of first child in provided container
      container.dataset.firstChildNodeType = container.firstElementChild.nodeName;

      // Get style for first child
      container.dataset.firstChildMargin = container.firstElementChild.style.marginRight;

      container.innerHTML = '';
      
      this.productHtml.forEach((html) => {
        const item = document.createElement(container.dataset.firstChildNodeType);
        item.className = container.dataset.firstChildClass;
        item.style.marginRight = container.dataset.firstChildMargin;
        item.innerHTML = html;

        container.appendChild(item);
      })
    })
  }
});